module.exports = __webpack_public_path__ + "img/jumbopack-active.d0bfcfe6.svg";